import { Action, createReducer, on } from '@ngrx/store';
import { loadLogoutRequest, loadLogoutSuccess, loadLogoutFailure } from '../actions/logout.actions';
import { ILogoutRequest } from '../models/logout.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

export const logoutFeatureKey = 'logout';

export interface LogoutState {
  isLoading: boolean;
  logoutRequest: ILogoutRequest;
  logoutSuccess: string;
  logoutFailure: IGenericError<ErrorResponse>;
}

export const initialState: LogoutState = {
  isLoading: false,
  logoutRequest: undefined,
  logoutSuccess: undefined,
  logoutFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadLogoutRequest, (state, action) => ({
    ...state,
    logoutRequest: action.request,
    isLoading: true
  })),
  on(loadLogoutSuccess, (state, action) => ({
    ...state,
    logoutSuccess: action.response,
    isLoading: false
  })),
  on(loadLogoutFailure, (state, action) => ({
    ...state,
    logoutFailure: action.error,
    isLoading: false
  }))
);

export const getLogoutRequest = (state: LogoutState) => state.logoutRequest;
export const getLogoutResponse = (state: LogoutState) => state.logoutSuccess;
export const getLogoutFailure = (state: LogoutState) => state.logoutFailure;
export const getLogoutIsLoading = (state: LogoutState) => state.isLoading;
